import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CropComponent } from './crop/crop.component';
import { ImageCropperModule } from 'ngx-image-cropper';


@NgModule({
  declarations: [CropComponent],
  imports: [
    CommonModule,ImageCropperModule 
  ],
  exports: [
    CropComponent
  ]
})
export class LibModule { }
